import CustomButton from '@/components/atoms/CustomButton';
import useOrganizationActivation from '@/hooks/organization/useOrganizationActivation';
import { TOrganizationSuperAdminExtended } from '@/types/Organization.types';
import { Text, VStack } from '@chakra-ui/react';
import React from 'react';

type Props = {
  organizationData: TOrganizationSuperAdminExtended;
};

const DeactivateOrganization = ({ organizationData }: Props) => {
  const { isPending, mutate } = useOrganizationActivation(organizationData._id, 'deactivate');

  return (
    <VStack
      padding={'40px'}
      boxShadow="0px 10px 80px 0px #00417926"
      background="white"
      borderRadius={'10px'}
      justifyContent={'center'}
      alignItems={'center'}
      marginTop={'15px'}
      maxWidth={'600px'}
      gap={'20px'}
    >
      <Text>
        Deactivating this organization will immediately revoke access for all users associated with it. This action will
        prevent members, admins, and peer support staff from logging in or accessing any organization-related data.
      </Text>
      <Text>Please confirm that you want to proceed.</Text>
      <CustomButton
        onClick={mutate}
        isLoading={isPending}
        label="Yes, I confirm"
        backgroundColor="red.500"
        labelHoverColor="red.500"
      />
    </VStack>
  );
};

export default DeactivateOrganization;
